import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  scrollTopMainPage() {
    document.getElementById('layout-content').scrollTop = 0;
  }
}